import { useNavigate } from '@remix-run/react'
import { useEffect } from 'react'

export function useShopifyNavigate() {
  const navigate = useNavigate()

  useEffect(() => {
    const handleNavigate = (event: Event): void => {
      const href = (event.target as HTMLElement).getAttribute('href')
      if (href) navigate(href)
    }

    document.addEventListener('shopify:navigate', handleNavigate)
    return () => {
      document.removeEventListener('shopify:navigate', handleNavigate)
    }
  }, [navigate])
}
